import { get } from 'lodash';

export const CURRENCY = {
  usd: 'usd',
  cad: 'cad',
  gbp: 'gbp',
  aud: 'aud',
};

export const COUNTRY_NAME = {
  US: 'United States',
  CA: 'Canada',
  GB: 'United Kingdom',
  GI: 'Gibraltar',
  AU: 'Australia',
};

export const COUNTRY_CODE = {
  US: 'US',
  CA: 'CA',
  GB: 'GB',
  GI: 'GI',
  AU: 'AU',
};

export const CURRENCY_COUNTRY_CODE = {
  [CURRENCY.usd]: COUNTRY_CODE.US,
  [CURRENCY.cad]: COUNTRY_CODE.CA,
  [CURRENCY.gbp]: COUNTRY_CODE.GB,
  [CURRENCY.aud]: COUNTRY_CODE.AU,
};

export const COUNTRY_CODE_BY_NAME = {
  [COUNTRY_NAME.US]: COUNTRY_CODE.US,
  [COUNTRY_NAME.CA]: COUNTRY_CODE.CA,
  [COUNTRY_NAME.GB]: COUNTRY_CODE.GB,
  [COUNTRY_NAME.GI]: COUNTRY_CODE.GI,
  [COUNTRY_NAME.AU]: COUNTRY_CODE.AU,
};

export const getCountryCodeByCountryAndCurrency = (shop) => {
  const currency = get(shop, 'currency', null);
  const country = get(shop, 'country', null) || get(shop, 'address.country', null);
  return COUNTRY_CODE_BY_NAME[country] || CURRENCY_COUNTRY_CODE[currency] || COUNTRY_CODE.US;
};



// WEBPACK FOOTER //
// ./src/app/utils/intl.js